import React, { useEffect, useState } from "react";
import { InitialCompanyStateType } from "../../assets/data/initialState";
import { FormikType } from "../../types/types";
import { BoldIcon, ErrorIcon, ItalicIcon } from "../../assets/icons/Icons";
import { HtmlTextInput } from "../Components";

export type Props = FormikType<InitialCompanyStateType>;

export default function CompanyDescription({ formik }: Props) {
  return (
    <div className="pb-8">
      <p className="font-Switzer font-bold text-2xl tracking-tight mb-1 color-black">
        Company Description
      </p>
      <p className="font-Switzer text-base tracking-tight mb-3 color-black">
        Include a thorough description of the Company. This makes it clearer for
        the user to understand what the company does.
      </p>
      <HtmlTextInput
        text={formik.values.description}
        onChange={(text) => formik.setFieldValue("description", text)}
      />
      {formik.touched.description && formik.errors.description && (
        <div
          className="w-full mt-5 flex items-center font-medium text-lg text-ErrorRed"
          role="alert"
        >
          <ErrorIcon className="mr-2" width={"28"} height={"28"} />
          {formik.errors.description}
        </div>
      )}
    </div>
  );
}
